// src/hooks/AuthContext.js
import { createContext } from 'react';

export const AuthContext = createContext({});
